module.exports = __webpack_public_path__ + "7043a5d4ede2c06bf4c26abfa439a93f.pdf";